module.exports = __webpack_public_path__ + "static/media/07_brand_pc.fc5dbc07.mp4";